export const htmlEmpty = (html: string | undefined) => {
  if (html === undefined) {
    return true
  }
  const div = document.createElement('div')
  div.innerHTML = html
  return (div.textContent || div.innerText) === ''
}
